import { formatCurrency } from '@src/utils/functions'
import { GraphQLErrorResponse } from './Bounty.code.api'

export const getErrorMessage = (error: GraphQLErrorResponse) => {
  const errorCode = error?.response?.json?.errors?.[0]?.message
  switch (errorCode) {
    case 'bounty_not_found':
      return 'This bounty doesn`t exist'
    case 'active_but_bonus_exists':
      return 'You already have an active bounty'
    case 'elite_seat_level_too_low':
      const requiredLevel = error?.response?.json?.errors[0]?.required_level
      return `You need to reach level ${requiredLevel} to grab this bounty`
    case 'balance_too_low':
      const requiredBalance = error?.response?.json?.errors[0]?.required_usd
      const formattedBalance = requiredBalance ? formatCurrency(requiredBalance) : 0
      return `Deposit a total of ${formattedBalance} to unlock`
    default:
      return 'Error grabbing bounty'
  }
}
